import {
  convertInvoiceV3toInvoiceModel,
  InvoiceDetailModel,
  InvoiceModel,
  InvoiceModelV3,
  InvoiceStatus,
  isInvoiceModelV3,
} from '@frontend/api-invoices';
import { calculateSurchargeAmount } from '@frontend/payments-hooks';

export const isSuccessfullyPaidInvoice = (invoice: InvoiceModel) =>
  invoice.payment &&
  (invoice.status === InvoiceStatus.Paid ||
    invoice.status === InvoiceStatus.PartiallyPaid ||
    invoice.payment?.status === 'SUCCEEDED');

export const isPaidInvoice = (invoice: InvoiceModel | InvoiceDetailModel | undefined) =>
  !!invoice &&
  (isSuccessfullyPaidInvoice(invoice) ||
    invoice.payment?.status === 'PENDING' ||
    invoice.status === InvoiceStatus.Pending);

export const isCanceledInvoice = (invoice: InvoiceModel) => invoice.status === InvoiceStatus.Canceled;

export const isFailedInvoice = (invoice: InvoiceModel) =>
  !!invoice.payment && invoice.payment.status === 'FAILED' && invoice.status !== InvoiceStatus.Paid;

export const isPartialPayment = (invoice: InvoiceModel) =>
  invoice.payment && invoice.billedAmount - invoice.payment.paidAmount > 0;

export const isCompletelyPaid = (invoice: InvoiceModel) => isPaidInvoice(invoice) && !isPartialPayment(invoice);

export const calculateInvoiceTotalDisplayAmount = (invoice: InvoiceModel | InvoiceModelV3) => {
  const inv = isInvoiceModelV3(invoice) ? convertInvoiceV3toInvoiceModel(invoice) : invoice;
  const isPaid = isPaidInvoice(inv);

  const billedAmount = invoice.billedAmount;

  let surchargeAmount = 0;
  if (invoice.surchargingEnabled) {
    surchargeAmount = isPaid
      ? invoice.appliedSurchargeAmount ?? 0
      : calculateSurchargeAmount(billedAmount, invoice.configuredSurchargeBasisPoints ?? 0);
  }

  return billedAmount + surchargeAmount;
};
